var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTech2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000732422,
    width: 90,
    height: 90,
    rx: 6,
    fill: "url(#paint0_linear_34_2325)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.4592 39.1387C63.5136 39.7337 61.1322 41.0506 59.5539 43.5971C58.5773 45.1837 58.0584 46.9309 58.1728 48.7714C58.4668 53.674 61.1322 56.3276 67.2169 57.8944C66.0745 61.8272 64.5178 65.5259 61.5742 68.4869C58.23 71.8585 54.0986 72.6518 49.8469 70.5237C46.9072 69.0601 44.1253 69.074 41.1856 70.5237C36.0559 73.0345 31.1136 71.4459 27.5288 66.2895C24.9974 62.6482 23.5828 58.5548 23.0304 54.1916C22.6555 51.2306 22.4227 48.1923 22.6358 45.2273C23.1863 37.8456 29.6438 31.9336 36.7642 32.2767C38.9049 32.3798 41.0633 33.1314 43.1073 33.8772C44.8198 34.5058 46.3035 34.486 48.014 33.8553C50.0541 33.1057 52.2204 32.3758 54.3591 32.2806C59.6052 32.0466 63.4702 34.6843 66.4592 39.1387ZM62.5626 37.8893C59.2974 34.8866 55.6849 33.7839 51.4904 35.077C50.1468 35.4895 48.815 35.9536 47.501 36.4653C46.2046 36.9796 44.76 36.9675 43.4723 36.4316C42.3161 35.9774 41.1284 35.6085 39.9564 35.196C38.2507 34.5646 36.4113 34.3883 34.6176 34.6843C29.192 35.6363 24.9817 40.6341 24.7765 46.3637C24.622 50.2578 25.11 54.1507 26.2207 57.8844C27.2683 61.3948 28.7362 64.689 31.4826 67.2434C33.6173 69.2267 36.0855 69.7959 38.8634 68.9332C39.3955 68.7736 39.9136 68.5699 40.4122 68.3243C43.8195 66.5889 47.1972 66.6246 50.6203 68.3243C54.2427 70.1251 57.6302 69.4766 60.272 66.5651C62.0891 64.5621 63.3222 62.2198 64.2397 59.6476C59.5184 57.9955 56.5155 54.7767 55.9966 49.771C55.4442 44.4935 57.8098 40.5488 62.5626 37.8893Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9471 18.3525C57.6357 27.1503 52.5534 31.5868 44.4741 30.97C43.7362 23.3008 47.8301 17.7913 56.9471 18.3525ZM54.5638 20.7741C49.7083 20.786 46.8239 24.1456 46.7963 28.5524C51.7366 28.7309 54.694 25.1055 54.5638 20.7741Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34_2325",
    x1: 0,
    y1: 0.000732422,
    x2: 90,
    y2: 97.2007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB66D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583FBB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTech2);
export default __webpack_public_path__ + "static/media/tech2.67d4698f8b3386c8106893a158e48889.svg";
export { ForwardRef as ReactComponent };